module.exports = __webpack_public_path__ + "img/jelly2.58d86894.jpg";